import { render, staticRenderFns } from "./ImageVideoModalContent.vue?vue&type=template&id=274f9381"
import script from "./ImageVideoModalContent.vue?vue&type=script&lang=ts"
export * from "./ImageVideoModalContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports